import { z } from 'zod'
import type LargeCardWithGridSection from '../LargeCardWithGridSection.vue'
import type HalfPageAdWithGridSection from '../HalfPageAdWithGridSection.vue'
import type ContentNewsMixSection from '../ContentNewsMixSection.vue'
import type CarouselWithGridSection from '../CarouselWithGridSection.vue'
import type GamesSection from '../GamesSection.vue'
import type CategoryMixSection from '../CategoryMixSection.vue'

const adBaseSchema = z.object({
  y: z.number(),
  x: z.number(),
  classes: z.string(),
})

export const aboveFoldSectionAdsSchema = z.object({
  billboardAdClasses: z.object({
    widgetId: z.string().optional(),
    classes: z.string().optional(),
  }),
  billboardAdSize: z.optional(
    z.union([z.literal('small'), z.literal('medium'), z.literal('large')])
  ),
  grid3: z.array(adBaseSchema),
  grid2: z.array(adBaseSchema),
  grid1: z.array(adBaseSchema),
})

export type SectionComponents = {
  LargeCardWithGridSection: typeof LargeCardWithGridSection
  HalfPageAdWithGridSection: typeof HalfPageAdWithGridSection
  ContentNewsMixSection: typeof ContentNewsMixSection
  CarouselWithGridSection: typeof CarouselWithGridSection
  GamesSection: typeof GamesSection
  CategoryMixSection: typeof CategoryMixSection
}

export type AdBase = z.infer<typeof adBaseSchema>
export type AboveFoldSectionAds = z.infer<typeof aboveFoldSectionAdsSchema>
